import { scrollToSection } from './scrollToSection';

export function scrollToNextSection() {
  scrollToSection('why-ai-section', 'hero-section');
}
